import { ChangeDetectionStrategy, Component, forwardRef, inject, input } from '@angular/core';
import type { IProductDataV3 } from '@df/catalog/product/product';
import { App } from '@df/core/app';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { UiComponent } from '@df/ui/ui.component';
import compact from 'lodash-es/compact';
import type { ProductDecorator } from '../../../../model/product/product.decorator';
import { ProductLayoutDeliveryPriceComponent } from '../delivery/price/product-layout-delivery-price.component';
import { ProductLayoutDetailsSectionsComponent } from '../details/sections/product-layout-details-sections.component';
import { ProductLayoutGiftBoxingComponent } from '../gift/boxing/product-layout-gift-boxing.component';
import { ProductLayoutComponent } from '../product-layout.component';
import { NProductLayout } from '../product-layout.interface';
import { ProductLayoutReviewsComponent } from '../reviews/product-layout-reviews.component';
import type { IProductSidebar } from '../sidebar/product-layout-sidebar.component';

@Component({
    selector: 'product-layout-summary',
    templateUrl: './product-layout-summary.component.html',
    styleUrl: './product-layout-summary.component.scss',
    imports: [
        ProductLayoutDeliveryPriceComponent,
        ProductLayoutDetailsSectionsComponent,
        forwardRef(() => ProductLayoutGiftBoxingComponent),
        ProductLayoutReviewsComponent,
        TranslatePipe
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductLayoutSummaryComponent extends UiComponent {
    readonly product = input.required<ProductDecorator<IProductDataV3>>();
    readonly content = input.required<NProductLayout.IContent>();
    readonly productViewLayout = input.required<ProductLayoutComponent>();

    private readonly app = inject(App);

    get isGiftBoxesEnabled() {
        return this.app.data.giftboxesEnabled;
    }

    get sidebars(): IProductSidebar[] {
        return compact([
            { title: 'Product Details', sidebar: 'details' },
            this.product().isFurniture ? { title: 'Dimensions', sidebar: 'dimensions' } : undefined,
            { title: 'Delivery & Returns', sidebar: 'delivery' },
            this.productViewLayout().showKlarna ? { title: 'Financing - Pay over time', sidebar: 'klarna' } : undefined
        ]);
    }
}
